export enum FeatureFlagName {
  NEW_CARD_FORM = 'pmmp_new_card_form',
  FILTER_YOUR_PAYMENTS = 'pmmp_filter_your_payments',
  YOUR_PAYMENTS_DISPLAY_REFUNDED = 'pmmp_your_payments_display_Refunded',
  PAY_NOW_BANNER = 'pay_now_banner',
}

export const flagKeys: FeatureFlagName[] = [
  FeatureFlagName.NEW_CARD_FORM,
  FeatureFlagName.FILTER_YOUR_PAYMENTS,
  FeatureFlagName.YOUR_PAYMENTS_DISPLAY_REFUNDED,
  FeatureFlagName.PAY_NOW_BANNER,
];

export const defaultFlagData = flagKeys.reduce((acc, item) => {
  return {
    ...acc,
    [item]: false,
  };
}, {});
